// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RequestHandlerScreen-module__font-s-10___wlduL {
  font-size: 10px !important;
}

.RequestHandlerScreen-module__font-s-12___xvyZ_ {
  font-size: 12px !important;
}

.RequestHandlerScreen-module__font-s-13___gFKVH {
  font-size: 13px !important;
}

.RequestHandlerScreen-module__font-s-14___I9iP_ {
  font-size: 14px !important;
}

.RequestHandlerScreen-module__font-s-15___izsc3 {
  font-size: 15px !important;
}

.RequestHandlerScreen-module__font-s-16___EcMU7 {
  font-size: 16px !important;
}

.RequestHandlerScreen-module__font-s-18___eXUx3 {
  font-size: 18px !important;
}

.RequestHandlerScreen-module__font-s-20___gufv8 {
  font-size: 20px !important;
}

.RequestHandlerScreen-module__font-s-22___fjhG6 {
  font-size: 22px !important;
}

.RequestHandlerScreen-module__font-s-28___aUWiI {
  font-size: 28px !important;
}

.RequestHandlerScreen-module__font-w-400___tIOot {
  font-weight: 400 !important;
}

.RequestHandlerScreen-module__font-w-500___dd_DC {
  font-weight: 500 !important;
}

.RequestHandlerScreen-module__font-w-600___zLfoS {
  font-weight: 600 !important;
}

.RequestHandlerScreen-module__font-w-700___syh0W {
  font-weight: 700 !important;
}

.RequestHandlerScreen-module__p-5___r3W6A {
  padding: 5px !important;
}

.RequestHandlerScreen-module__p-12___mJNOe {
  padding: 12px !important;
}

.RequestHandlerScreen-module__p-16___t1ZQH {
  padding: 16px !important;
}

.RequestHandlerScreen-module__p-30___EuKyA {
  padding: 30px !important;
}

.RequestHandlerScreen-module__p-b-0___TWFZS {
  padding-bottom: 0 !important;
}

.RequestHandlerScreen-module__p-b-5____ayzD {
  padding-bottom: 5px !important;
}

.RequestHandlerScreen-module__p-b-10___y7E5T {
  padding-bottom: 10px !important;
}

.RequestHandlerScreen-module__p-b-12___mY_lB {
  padding-bottom: 12px !important;
}

.RequestHandlerScreen-module__p-b-16___lvRCf {
  padding-bottom: 16px !important;
}

.RequestHandlerScreen-module__p-b-18___h1W4W {
  padding-bottom: 18px !important;
}

.RequestHandlerScreen-module__p-b-20___uVR2M {
  padding-bottom: 20px !important;
}

.RequestHandlerScreen-module__p-b-25___SS56k {
  padding-bottom: 25px !important;
}

.RequestHandlerScreen-module__p-b-30___Ys8lS {
  padding-bottom: 30px !important;
}

.RequestHandlerScreen-module__p-b-50___vtv5F {
  padding-bottom: 50px !important;
}

.RequestHandlerScreen-module__p-t-0___SI4e7 {
  padding-top: 0 !important;
}

.RequestHandlerScreen-module__p-t-12___WsrhD {
  padding-top: 12px !important;
}

.RequestHandlerScreen-module__p-t-16___ciFwk {
  padding-top: 16px !important;
}

.RequestHandlerScreen-module__p-t-18___YfAnM {
  padding-top: 18px !important;
}

.RequestHandlerScreen-module__p-t-20___hlbqs {
  padding-top: 20px !important;
}

.RequestHandlerScreen-module__p-t-30___v7JAv {
  padding-top: 30px !important;
}

.RequestHandlerScreen-module__p-t-40___c1b2v {
  padding-top: 40px !important;
}

.RequestHandlerScreen-module__p-t-50___BPa02 {
  padding-top: 50px !important;
}

.RequestHandlerScreen-module__p-l-20___FCN2c {
  padding-left: 20px !important;
}

.RequestHandlerScreen-module__p-l-30___sxp2t {
  padding-left: 30px !important;
}

.RequestHandlerScreen-module__p-l-40____Wj_H {
  padding-left: 40px !important;
}

.RequestHandlerScreen-module__p-r-16___09Mql {
  padding-right: 16px !important;
}

.RequestHandlerScreen-module__p-r-20___rpYoN {
  padding-right: 20px !important;
}

.RequestHandlerScreen-module__p-r-30___n0mVo {
  padding-right: 30px !important;
}

.RequestHandlerScreen-module__p-r-50___GbKPt {
  padding-right: 50px !important;
}

.RequestHandlerScreen-module__p-r-60___UG67f {
  padding-right: 60px !important;
}

.RequestHandlerScreen-module__m-b-1___gPxor {
  margin-bottom: 1px !important;
}

.RequestHandlerScreen-module__m-b-2___gyDKv {
  margin-bottom: 2px !important;
}

.RequestHandlerScreen-module__m-b-6___w2NKm {
  margin-bottom: 6px !important;
}

.RequestHandlerScreen-module__m-b-8___N4xa5 {
  margin-bottom: 8px !important;
}

.RequestHandlerScreen-module__m-b-10___mnmRC {
  margin-bottom: 10px !important;
}

.RequestHandlerScreen-module__m-b-14___X9a1u {
  margin-bottom: 14px !important;
}

.RequestHandlerScreen-module__m-b-16___DNGZi {
  margin-bottom: 16px !important;
}

.RequestHandlerScreen-module__m-b-20___A6B_j {
  margin-bottom: 20px !important;
}

.RequestHandlerScreen-module__m-b-22___dyrpn {
  margin-bottom: 22px !important;
}

.RequestHandlerScreen-module__m-b-24___F41Vm {
  margin-bottom: 24px !important;
}

.RequestHandlerScreen-module__m-b-30___nJbcW {
  margin-bottom: 30px !important;
}

.RequestHandlerScreen-module__m-b-32___elVLN {
  margin-bottom: 32px !important;
}

.RequestHandlerScreen-module__m-b-40___FdpNI {
  margin-bottom: 40px !important;
}

.RequestHandlerScreen-module__m-t-2___z2pOK {
  margin-top: 2px !important;
}

.RequestHandlerScreen-module__m-t-3___czOCf {
  margin-top: 3px !important;
}

.RequestHandlerScreen-module__m-t-4___ElX2u {
  margin-top: 4px !important;
}

.RequestHandlerScreen-module__m-t-5___txgZ0 {
  margin-top: 5px !important;
}

.RequestHandlerScreen-module__m-t-8___QCYIH {
  margin-top: 8px !important;
}

.RequestHandlerScreen-module__m-t-10___iXJ3w {
  margin-top: 10px !important;
}

.RequestHandlerScreen-module__m-t-15___SVH8A {
  margin-top: 15px !important;
}

.RequestHandlerScreen-module__m-t-16___Chy4Z {
  margin-top: 16px !important;
}

.RequestHandlerScreen-module__m-t-20___GnThO {
  margin-top: 20px !important;
}

.RequestHandlerScreen-module__m-t-22___OPoo8 {
  margin-top: 22px !important;
}

.RequestHandlerScreen-module__m-t-30___LK_4n {
  margin-top: 30px !important;
}

.RequestHandlerScreen-module__m-t-32___vTdav {
  margin-top: 32px !important;
}

.RequestHandlerScreen-module__m-l-auto___mrhws {
  margin-left: auto !important;
}

.RequestHandlerScreen-module__m-l-4___ixQGA {
  margin-left: 4px !important;
}

.RequestHandlerScreen-module__m-l-5___My390 {
  margin-left: 5px !important;
}

.RequestHandlerScreen-module__m-l-6___P5p1t {
  margin-left: 6px !important;
}

.RequestHandlerScreen-module__m-l-8___gtyCi {
  margin-left: 8px !important;
}

.RequestHandlerScreen-module__m-l-10___v57Og {
  margin-left: 10px !important;
}

.RequestHandlerScreen-module__m-l-16___vVKzY {
  margin-left: 16px !important;
}

.RequestHandlerScreen-module__m-l-20___o34C1 {
  margin-left: 20px !important;
}

.RequestHandlerScreen-module__m-l-24___TbRct {
  margin-left: 24px !important;
}

.RequestHandlerScreen-module__m-l-30___xZAmm {
  margin-left: 30px !important;
}

.RequestHandlerScreen-module__m-l-35___aN87D {
  margin-left: 35px !important;
}

.RequestHandlerScreen-module__m-l-40___cTeQG {
  margin-left: 40px !important;
}

.RequestHandlerScreen-module__m-r-8___WQbsZ {
  margin-right: 8px !important;
}

.RequestHandlerScreen-module__m-r-10___yvw6Q {
  margin-right: 10px !important;
}

.RequestHandlerScreen-module__m-r-16___CAral {
  margin-right: 16px !important;
}

.RequestHandlerScreen-module__m-r-20___TZOc7 {
  margin-right: 20px !important;
}

.RequestHandlerScreen-module__m-r-24___PYInm {
  margin-right: 24px !important;
}

.RequestHandlerScreen-module__m-r-30___WPgbt {
  margin-right: 30px !important;
}

.RequestHandlerScreen-module__m-r-40___RI_1S {
  margin-right: 40px !important;
}

.RequestHandlerScreen-module__border-r-3___f19N_ {
  border-radius: 3px !important;
}

.RequestHandlerScreen-module__border-r-4___dx0GA {
  border-radius: 4px !important;
}

.RequestHandlerScreen-module__border-r-6___Ha5RQ {
  border-radius: 6px !important;
}

.RequestHandlerScreen-module__border-r-10___B1Hlv {
  border-radius: 10px !important;
}

.RequestHandlerScreen-module__border-r-12___rEUOf {
  border-radius: 12px !important;
}

.RequestHandlerScreen-module__border-r-16___OMXXp {
  border-radius: 16px !important;
}

.RequestHandlerScreen-module__border-r-50___L9XLI {
  border-radius: 50% !important;
}

.RequestHandlerScreen-module__primary-border___K8wBT {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.RequestHandlerScreen-module__primary-border-b____o9HX {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.RequestHandlerScreen-module__primary-border-t___gt5Vt {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.RequestHandlerScreen-module__primary-border-l___Zi349 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.RequestHandlerScreen-module__primary-border-r___gARcL {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.RequestHandlerScreen-module__secondary-border___VPNpC {
  border: 1px solid #637768;
}

.RequestHandlerScreen-module__secondary-border-b___Xc8PK {
  border-bottom: 1px solid #637768;
}

.RequestHandlerScreen-module__secondary-border-t___Ih4lj {
  border-top: 1px solid #637768;
}

.RequestHandlerScreen-module__secondary-border-l___EVMPn {
  border-left: 1px solid #637768;
}

.RequestHandlerScreen-module__secondary-border-r___AAkh0 {
  border-right: 1px solid #637768;
}

.RequestHandlerScreen-module__gap-0___yqKPL {
  gap: 0 !important;
}

.RequestHandlerScreen-module__gap-2___wh8X7 {
  gap: 2px !important;
}

.RequestHandlerScreen-module__gap-4___VQt_I {
  gap: 4px !important;
}

.RequestHandlerScreen-module__gap-5___bcdTX {
  gap: 5px !important;
}

.RequestHandlerScreen-module__gap-6___i0vRA {
  gap: 6px !important;
}

.RequestHandlerScreen-module__gap-8___B0z7k {
  gap: 8px !important;
}

.RequestHandlerScreen-module__gap-10___tHZLW {
  gap: 10px !important;
}

.RequestHandlerScreen-module__gap-12___HbO41 {
  gap: 12px !important;
}

.RequestHandlerScreen-module__gap-14___iaDzb {
  gap: 14px !important;
}

.RequestHandlerScreen-module__gap-16___qPhBV {
  gap: 16px !important;
}

.RequestHandlerScreen-module__gap-18___da27o {
  gap: 18px !important;
}

.RequestHandlerScreen-module__gap-20___DWU8o {
  gap: 20px !important;
}

.RequestHandlerScreen-module__gap-24___o5FGW {
  gap: 24px !important;
}

.RequestHandlerScreen-module__gap-26___ecc5l {
  gap: 26px !important;
}

.RequestHandlerScreen-module__gap-30___PoWJi {
  gap: 30px !important;
}

.RequestHandlerScreen-module__gap-32___Km4_k {
  gap: 32px !important;
}

.RequestHandlerScreen-module__gap-40___MR_EZ {
  gap: 40px !important;
}

.RequestHandlerScreen-module__gap-50___fE_BK {
  gap: 50px !important;
}

.RequestHandlerScreen-module__flex-1___Jdfqf {
  flex: 1;
}

.RequestHandlerScreen-module__flex-none___uSEdK {
  flex: none !important;
}

.RequestHandlerScreen-module__flex-column___cUH9G {
  display: flex;
  flex-direction: column !important;
}

.RequestHandlerScreen-module__flex-row___JTijS {
  display: flex;
  flex-direction: row !important;
}

.RequestHandlerScreen-module__vertically-centered___WwzOO {
  display: flex;
  align-items: center !important;
}

.RequestHandlerScreen-module__horizontally-centered___CbFoJ {
  display: flex;
  justify-content: center !important;
}

.RequestHandlerScreen-module__horizontally-end___DrIUf {
  display: flex;
  justify-content: end !important;
}

.RequestHandlerScreen-module__vertically-start___r36wy {
  display: flex;
  align-items: start !important;
}

.RequestHandlerScreen-module__space-between___HSKG9 {
  display: flex;
  justify-content: space-between !important;
}

.RequestHandlerScreen-module__flex-wrap___v1YVM {
  flex-wrap: wrap !important;
}

.RequestHandlerScreen-module__height-100___H_a0D {
  height: 100%;
}

.RequestHandlerScreen-module__width-50___J9lB7 {
  width: 50% !important;
}

.RequestHandlerScreen-module__width-100___nikSr {
  width: 100%;
}

.RequestHandlerScreen-module__cursor-pointer___ebr31 {
  cursor: pointer;
}

.RequestHandlerScreen-module__cursor-not-allowed___ggqpk {
  cursor: not-allowed !important;
}

.RequestHandlerScreen-module__absolute-centered___pHMMy {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.RequestHandlerScreen-module__absolute___4e2Od {
  position: absolute;
}

.RequestHandlerScreen-module__relative___NtuTr {
  position: relative;
}

.RequestHandlerScreen-module__fixed___O3xIs {
  position: fixed;
}

.RequestHandlerScreen-module__visible___CMWKW {
  opacity: 1;
}

.RequestHandlerScreen-module__invisible___oXTl_ {
  opacity: 0;
}

.RequestHandlerScreen-module__col-90___iIq3b {
  width: 90% !important;
}

.RequestHandlerScreen-module__col-auto___IpIms {
  width: auto !important;
}

.RequestHandlerScreen-module__medical-tabs___xPGFM {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.RequestHandlerScreen-module__medical-table-new___QhedS {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.RequestHandlerScreen-module__medical-table-new___QhedS:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.RequestHandlerScreen-module__medical-table-new___QhedS::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.RequestHandlerScreen-module__medical-table-new___QhedS::-webkit-scrollbar-track {
  display: none;
}
.RequestHandlerScreen-module__medical-table-new___QhedS.RequestHandlerScreen-module__no-pagination___HUUFf {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.RequestHandlerScreen-module__medical-table-new___QhedS.RequestHandlerScreen-module__no-pagination___HUUFf:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.RequestHandlerScreen-module__medical-table-new___QhedS.RequestHandlerScreen-module__no-pagination___HUUFf::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.RequestHandlerScreen-module__medical-table-new___QhedS.RequestHandlerScreen-module__no-pagination___HUUFf::-webkit-scrollbar-track {
  display: none;
}

.RequestHandlerScreen-module__medical-table-empty___q97bA {
  padding: 14px 40px !important;
}

.RequestHandlerScreen-module__icon-btn___F6iGd {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.RequestHandlerScreen-module__search-icon___HgRgx {
  width: 24px;
  height: 24px;
  align-self: center;
}

.RequestHandlerScreen-module__disable-select___VTelz {
  user-select: none;
}

.RequestHandlerScreen-module__break-word___SmcyI {
  word-break: break-word;
}

.RequestHandlerScreen-module__popup-clear-btn___RzgbG {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.RequestHandlerScreen-module__scroll-m-b-20___CuFJz {
  scroll-margin-bottom: 20px;
}

@keyframes RequestHandlerScreen-module__loading___vWK0u {
  0% {
    width: 100px;
    height: 100px;
  }
  20% {
    width: 105px;
    height: 105px;
  }
  40% {
    width: 110px;
    height: 110px;
  }
  60% {
    width: 105px;
    height: 105px;
  }
  80% {
    width: 100px;
    height: 100px;
  }
  100% {
    width: 100px;
    height: 100px;
  }
}
.RequestHandlerScreen-module__container___enKvL {
  justify-content: center;
  height: 80vh;
  width: 90%;
  margin: 0 auto;
  padding: 15px 10px;
}
.RequestHandlerScreen-module__container___enKvL .RequestHandlerScreen-module__imgContainer___cMAbI {
  min-height: 115px;
}
.RequestHandlerScreen-module__container___enKvL .RequestHandlerScreen-module__imgContainer___cMAbI .RequestHandlerScreen-module__img___PrEvk {
  width: 100px;
  height: 100px;
  animation: RequestHandlerScreen-module__loading___vWK0u 1.4s infinite linear;
  object-fit: contain;
}
.RequestHandlerScreen-module__container___enKvL .RequestHandlerScreen-module__statusContainer___fJQU0 {
  color: #17335b;
}
.RequestHandlerScreen-module__container___enKvL .RequestHandlerScreen-module__statusContainer___fJQU0 .RequestHandlerScreen-module__statusTextSecondary___JQNKy {
  font-family: var(--font-family);
  font-weight: 600;
  font-size: 1rem;
  text-align: center;
}
.RequestHandlerScreen-module__container___enKvL .RequestHandlerScreen-module__statusText___xd5_S {
  font-family: var(--font-family);
  font-weight: 900;
  font-size: 1.2rem;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/RequestHandlerScreen/RequestHandlerScreen.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss","webpack://./../common/src/styles/global/_weights.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE;IACE,YAAA;IACA,aAAA;EA8pBF;EA5pBA;IACE,YAAA;IACA,aAAA;EA8pBF;EA5pBA;IACE,YAAA;IACA,aAAA;EA8pBF;EA5pBA;IACE,YAAA;IACA,aAAA;EA8pBF;EA5pBA;IACE,YAAA;IACA,aAAA;EA8pBF;EA5pBA;IACE,YAAA;IACA,aAAA;EA8pBF;AACF;AA3pBA;EACE,uBAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;AA6pBF;AA3pBE;EACE,iBAAA;AA6pBJ;AA3pBI;EACE,YAAA;EACA,aAAA;EACA,4EAAA;EACA,mBAAA;AA6pBN;AAzpBE;EACE,cAAA;AA2pBJ;AAzpBI;EExBF,+BApBO;EAqBP,gBCvBU;EDwBV,eAAA;EFwBI,kBAAA;AA6pBN;AAzpBE;EE9BA,+BApBO;EAqBP,gBCrBM;EDsBN,iBAAA;EF8BE,kBAAA;AA6pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n@keyframes loading {\n  0% {\n    width: 100px;\n    height: 100px;\n  }\n  20% {\n    width: 105px;\n    height: 105px;\n  }\n  40% {\n    width: 110px;\n    height: 110px;\n  }\n  60% {\n    width: 105px;\n    height: 105px;\n  }\n  80% {\n    width: 100px;\n    height: 100px;\n  }\n  100% {\n    width: 100px;\n    height: 100px;\n  }\n}\n\n.container {\n  justify-content: center;\n  height: 80vh;\n  width: 90%;\n  margin: 0 auto;\n  padding: $row-element-horizontal $row-padding-vertical;\n\n  .imgContainer {\n    min-height: 115px;\n\n    .img {\n      width: 100px;\n      height: 100px;\n      animation: loading 1.4s infinite linear;\n      object-fit: contain;\n    }\n  }\n\n  .statusContainer {\n    color: get-color(blue, dark);\n\n    .statusTextSecondary {\n      @include get-font($roboto, $semi-bold, medium);\n      text-align: center;\n    }\n  }\n\n  .statusText {\n    @include get-font($roboto, $heavy, large);\n    text-align: center;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n","$extra-light: 200;\n$light: 300;\n$regular: 400;\n$medium: 500;\n$semi-bold: 600;\n$bold: 700;\n$heavy: 900;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `RequestHandlerScreen-module__font-s-10___wlduL`,
	"fontS12": `RequestHandlerScreen-module__font-s-12___xvyZ_`,
	"fontS13": `RequestHandlerScreen-module__font-s-13___gFKVH`,
	"fontS14": `RequestHandlerScreen-module__font-s-14___I9iP_`,
	"fontS15": `RequestHandlerScreen-module__font-s-15___izsc3`,
	"fontS16": `RequestHandlerScreen-module__font-s-16___EcMU7`,
	"fontS18": `RequestHandlerScreen-module__font-s-18___eXUx3`,
	"fontS20": `RequestHandlerScreen-module__font-s-20___gufv8`,
	"fontS22": `RequestHandlerScreen-module__font-s-22___fjhG6`,
	"fontS28": `RequestHandlerScreen-module__font-s-28___aUWiI`,
	"fontW400": `RequestHandlerScreen-module__font-w-400___tIOot`,
	"fontW500": `RequestHandlerScreen-module__font-w-500___dd_DC`,
	"fontW600": `RequestHandlerScreen-module__font-w-600___zLfoS`,
	"fontW700": `RequestHandlerScreen-module__font-w-700___syh0W`,
	"p5": `RequestHandlerScreen-module__p-5___r3W6A`,
	"p12": `RequestHandlerScreen-module__p-12___mJNOe`,
	"p16": `RequestHandlerScreen-module__p-16___t1ZQH`,
	"p30": `RequestHandlerScreen-module__p-30___EuKyA`,
	"pB0": `RequestHandlerScreen-module__p-b-0___TWFZS`,
	"pB5": `RequestHandlerScreen-module__p-b-5____ayzD`,
	"pB10": `RequestHandlerScreen-module__p-b-10___y7E5T`,
	"pB12": `RequestHandlerScreen-module__p-b-12___mY_lB`,
	"pB16": `RequestHandlerScreen-module__p-b-16___lvRCf`,
	"pB18": `RequestHandlerScreen-module__p-b-18___h1W4W`,
	"pB20": `RequestHandlerScreen-module__p-b-20___uVR2M`,
	"pB25": `RequestHandlerScreen-module__p-b-25___SS56k`,
	"pB30": `RequestHandlerScreen-module__p-b-30___Ys8lS`,
	"pB50": `RequestHandlerScreen-module__p-b-50___vtv5F`,
	"pT0": `RequestHandlerScreen-module__p-t-0___SI4e7`,
	"pT12": `RequestHandlerScreen-module__p-t-12___WsrhD`,
	"pT16": `RequestHandlerScreen-module__p-t-16___ciFwk`,
	"pT18": `RequestHandlerScreen-module__p-t-18___YfAnM`,
	"pT20": `RequestHandlerScreen-module__p-t-20___hlbqs`,
	"pT30": `RequestHandlerScreen-module__p-t-30___v7JAv`,
	"pT40": `RequestHandlerScreen-module__p-t-40___c1b2v`,
	"pT50": `RequestHandlerScreen-module__p-t-50___BPa02`,
	"pL20": `RequestHandlerScreen-module__p-l-20___FCN2c`,
	"pL30": `RequestHandlerScreen-module__p-l-30___sxp2t`,
	"pL40": `RequestHandlerScreen-module__p-l-40____Wj_H`,
	"pR16": `RequestHandlerScreen-module__p-r-16___09Mql`,
	"pR20": `RequestHandlerScreen-module__p-r-20___rpYoN`,
	"pR30": `RequestHandlerScreen-module__p-r-30___n0mVo`,
	"pR50": `RequestHandlerScreen-module__p-r-50___GbKPt`,
	"pR60": `RequestHandlerScreen-module__p-r-60___UG67f`,
	"mB1": `RequestHandlerScreen-module__m-b-1___gPxor`,
	"mB2": `RequestHandlerScreen-module__m-b-2___gyDKv`,
	"mB6": `RequestHandlerScreen-module__m-b-6___w2NKm`,
	"mB8": `RequestHandlerScreen-module__m-b-8___N4xa5`,
	"mB10": `RequestHandlerScreen-module__m-b-10___mnmRC`,
	"mB14": `RequestHandlerScreen-module__m-b-14___X9a1u`,
	"mB16": `RequestHandlerScreen-module__m-b-16___DNGZi`,
	"mB20": `RequestHandlerScreen-module__m-b-20___A6B_j`,
	"mB22": `RequestHandlerScreen-module__m-b-22___dyrpn`,
	"mB24": `RequestHandlerScreen-module__m-b-24___F41Vm`,
	"mB30": `RequestHandlerScreen-module__m-b-30___nJbcW`,
	"mB32": `RequestHandlerScreen-module__m-b-32___elVLN`,
	"mB40": `RequestHandlerScreen-module__m-b-40___FdpNI`,
	"mT2": `RequestHandlerScreen-module__m-t-2___z2pOK`,
	"mT3": `RequestHandlerScreen-module__m-t-3___czOCf`,
	"mT4": `RequestHandlerScreen-module__m-t-4___ElX2u`,
	"mT5": `RequestHandlerScreen-module__m-t-5___txgZ0`,
	"mT8": `RequestHandlerScreen-module__m-t-8___QCYIH`,
	"mT10": `RequestHandlerScreen-module__m-t-10___iXJ3w`,
	"mT15": `RequestHandlerScreen-module__m-t-15___SVH8A`,
	"mT16": `RequestHandlerScreen-module__m-t-16___Chy4Z`,
	"mT20": `RequestHandlerScreen-module__m-t-20___GnThO`,
	"mT22": `RequestHandlerScreen-module__m-t-22___OPoo8`,
	"mT30": `RequestHandlerScreen-module__m-t-30___LK_4n`,
	"mT32": `RequestHandlerScreen-module__m-t-32___vTdav`,
	"mLAuto": `RequestHandlerScreen-module__m-l-auto___mrhws`,
	"mL4": `RequestHandlerScreen-module__m-l-4___ixQGA`,
	"mL5": `RequestHandlerScreen-module__m-l-5___My390`,
	"mL6": `RequestHandlerScreen-module__m-l-6___P5p1t`,
	"mL8": `RequestHandlerScreen-module__m-l-8___gtyCi`,
	"mL10": `RequestHandlerScreen-module__m-l-10___v57Og`,
	"mL16": `RequestHandlerScreen-module__m-l-16___vVKzY`,
	"mL20": `RequestHandlerScreen-module__m-l-20___o34C1`,
	"mL24": `RequestHandlerScreen-module__m-l-24___TbRct`,
	"mL30": `RequestHandlerScreen-module__m-l-30___xZAmm`,
	"mL35": `RequestHandlerScreen-module__m-l-35___aN87D`,
	"mL40": `RequestHandlerScreen-module__m-l-40___cTeQG`,
	"mR8": `RequestHandlerScreen-module__m-r-8___WQbsZ`,
	"mR10": `RequestHandlerScreen-module__m-r-10___yvw6Q`,
	"mR16": `RequestHandlerScreen-module__m-r-16___CAral`,
	"mR20": `RequestHandlerScreen-module__m-r-20___TZOc7`,
	"mR24": `RequestHandlerScreen-module__m-r-24___PYInm`,
	"mR30": `RequestHandlerScreen-module__m-r-30___WPgbt`,
	"mR40": `RequestHandlerScreen-module__m-r-40___RI_1S`,
	"borderR3": `RequestHandlerScreen-module__border-r-3___f19N_`,
	"borderR4": `RequestHandlerScreen-module__border-r-4___dx0GA`,
	"borderR6": `RequestHandlerScreen-module__border-r-6___Ha5RQ`,
	"borderR10": `RequestHandlerScreen-module__border-r-10___B1Hlv`,
	"borderR12": `RequestHandlerScreen-module__border-r-12___rEUOf`,
	"borderR16": `RequestHandlerScreen-module__border-r-16___OMXXp`,
	"borderR50": `RequestHandlerScreen-module__border-r-50___L9XLI`,
	"primaryBorder": `RequestHandlerScreen-module__primary-border___K8wBT`,
	"primaryBorderB": `RequestHandlerScreen-module__primary-border-b____o9HX`,
	"primaryBorderT": `RequestHandlerScreen-module__primary-border-t___gt5Vt`,
	"primaryBorderL": `RequestHandlerScreen-module__primary-border-l___Zi349`,
	"primaryBorderR": `RequestHandlerScreen-module__primary-border-r___gARcL`,
	"secondaryBorder": `RequestHandlerScreen-module__secondary-border___VPNpC`,
	"secondaryBorderB": `RequestHandlerScreen-module__secondary-border-b___Xc8PK`,
	"secondaryBorderT": `RequestHandlerScreen-module__secondary-border-t___Ih4lj`,
	"secondaryBorderL": `RequestHandlerScreen-module__secondary-border-l___EVMPn`,
	"secondaryBorderR": `RequestHandlerScreen-module__secondary-border-r___AAkh0`,
	"gap0": `RequestHandlerScreen-module__gap-0___yqKPL`,
	"gap2": `RequestHandlerScreen-module__gap-2___wh8X7`,
	"gap4": `RequestHandlerScreen-module__gap-4___VQt_I`,
	"gap5": `RequestHandlerScreen-module__gap-5___bcdTX`,
	"gap6": `RequestHandlerScreen-module__gap-6___i0vRA`,
	"gap8": `RequestHandlerScreen-module__gap-8___B0z7k`,
	"gap10": `RequestHandlerScreen-module__gap-10___tHZLW`,
	"gap12": `RequestHandlerScreen-module__gap-12___HbO41`,
	"gap14": `RequestHandlerScreen-module__gap-14___iaDzb`,
	"gap16": `RequestHandlerScreen-module__gap-16___qPhBV`,
	"gap18": `RequestHandlerScreen-module__gap-18___da27o`,
	"gap20": `RequestHandlerScreen-module__gap-20___DWU8o`,
	"gap24": `RequestHandlerScreen-module__gap-24___o5FGW`,
	"gap26": `RequestHandlerScreen-module__gap-26___ecc5l`,
	"gap30": `RequestHandlerScreen-module__gap-30___PoWJi`,
	"gap32": `RequestHandlerScreen-module__gap-32___Km4_k`,
	"gap40": `RequestHandlerScreen-module__gap-40___MR_EZ`,
	"gap50": `RequestHandlerScreen-module__gap-50___fE_BK`,
	"flex1": `RequestHandlerScreen-module__flex-1___Jdfqf`,
	"flexNone": `RequestHandlerScreen-module__flex-none___uSEdK`,
	"flexColumn": `RequestHandlerScreen-module__flex-column___cUH9G`,
	"flexRow": `RequestHandlerScreen-module__flex-row___JTijS`,
	"verticallyCentered": `RequestHandlerScreen-module__vertically-centered___WwzOO`,
	"horizontallyCentered": `RequestHandlerScreen-module__horizontally-centered___CbFoJ`,
	"horizontallyEnd": `RequestHandlerScreen-module__horizontally-end___DrIUf`,
	"verticallyStart": `RequestHandlerScreen-module__vertically-start___r36wy`,
	"spaceBetween": `RequestHandlerScreen-module__space-between___HSKG9`,
	"flexWrap": `RequestHandlerScreen-module__flex-wrap___v1YVM`,
	"height100": `RequestHandlerScreen-module__height-100___H_a0D`,
	"width50": `RequestHandlerScreen-module__width-50___J9lB7`,
	"width100": `RequestHandlerScreen-module__width-100___nikSr`,
	"cursorPointer": `RequestHandlerScreen-module__cursor-pointer___ebr31`,
	"cursorNotAllowed": `RequestHandlerScreen-module__cursor-not-allowed___ggqpk`,
	"absoluteCentered": `RequestHandlerScreen-module__absolute-centered___pHMMy`,
	"absolute": `RequestHandlerScreen-module__absolute___4e2Od`,
	"relative": `RequestHandlerScreen-module__relative___NtuTr`,
	"fixed": `RequestHandlerScreen-module__fixed___O3xIs`,
	"visible": `RequestHandlerScreen-module__visible___CMWKW`,
	"invisible": `RequestHandlerScreen-module__invisible___oXTl_`,
	"col90": `RequestHandlerScreen-module__col-90___iIq3b`,
	"colAuto": `RequestHandlerScreen-module__col-auto___IpIms`,
	"medicalTabs": `RequestHandlerScreen-module__medical-tabs___xPGFM`,
	"medicalTableNew": `RequestHandlerScreen-module__medical-table-new___QhedS`,
	"noPagination": `RequestHandlerScreen-module__no-pagination___HUUFf`,
	"medicalTableEmpty": `RequestHandlerScreen-module__medical-table-empty___q97bA`,
	"iconBtn": `RequestHandlerScreen-module__icon-btn___F6iGd`,
	"searchIcon": `RequestHandlerScreen-module__search-icon___HgRgx`,
	"disableSelect": `RequestHandlerScreen-module__disable-select___VTelz`,
	"breakWord": `RequestHandlerScreen-module__break-word___SmcyI`,
	"popupClearBtn": `RequestHandlerScreen-module__popup-clear-btn___RzgbG`,
	"scrollMB20": `RequestHandlerScreen-module__scroll-m-b-20___CuFJz`,
	"container": `RequestHandlerScreen-module__container___enKvL`,
	"imgContainer": `RequestHandlerScreen-module__imgContainer___cMAbI`,
	"img": `RequestHandlerScreen-module__img___PrEvk`,
	"loading": `RequestHandlerScreen-module__loading___vWK0u`,
	"statusContainer": `RequestHandlerScreen-module__statusContainer___fJQU0`,
	"statusTextSecondary": `RequestHandlerScreen-module__statusTextSecondary___JQNKy`,
	"statusText": `RequestHandlerScreen-module__statusText___xd5_S`
};
module.exports = ___CSS_LOADER_EXPORT___;
